import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LoginComponent } from './login.component';
import { RouterModule } from '@angular/router';
import { AlertModule } from 'ngx-bootstrap/alert';
import { LoginService } from 'src/app/core/services/login.service';
import { MaterialModule } from 'src/app/core/material/material.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MessageWarnModule } from '../message-warn/message-warn.module';
import { FooterModule } from '../footer/footer.module';

@NgModule({
  declarations: [LoginComponent],
  exports: [LoginComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: LoginComponent
      }
    ]),
    TranslateModule.forChild({
      isolate: false
    }),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule.forRoot(),
    MaterialModule,
    ToolbarModule,
    SharedModule,
    MessageWarnModule,
    FooterModule
  ],
  providers: [LoginService]
})
export class LoginModule {}
